/**
 * 获取用户url的参数http://www.cnblogs.com/xyyt/p/6068981.html
 */
export default{
  getUrlKey: function (name) {
    return ((new RegExp('[?|&]' + name + '=' + '([^&;]+?)(&|#|;|$)').exec(location.href) || [, ""])[1].replace(/\+/g, '%20')) || null;
  }
}




// WEBPACK FOOTER //
// ./src/common/js/utils.js